import type {ReactElement} from 'react';
import React, { useRef, useState, useEffect} from 'react';
import type {PosterOpts} from '@PosterWhiteboard/poster/poster.class';
import {PosterWhiteboard} from '@Components/poster-whiteboard';
import {useFullscreen} from 'ahooks';
import {onUserInactive} from '@Utils/activity.util';
import {Thumbnail} from '@Components/thumbnail';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import LogoFull from '@Assets/logo-postermaker-light.svg';
import styles from './poster-webpage.module.scss';
import {PosterWebPageNavBar} from './components/poster-web-page-nav-bar';

const INACTIVE_USER_DELAY = 6000;

export interface PosterWebPageConfig {
  canEditPoster: boolean;
  qrCodeUrl: string;
}

export interface PosterWebpageProps {
  className?: string;
  posterOpts: PosterOpts;
  posterWebPageConfig: PosterWebPageConfig;
}

export function PosterWebpage({className = '', ...props}: PosterWebpageProps): ReactElement<any> | null {
  const posterWebpageRef = useRef<HTMLDivElement>(null);
  const [isFullscreen, {toggleFullscreen}] = useFullscreen(posterWebpageRef);
  const [isNavBarVisible, setIsNavBarVisible] = useState(true);

  useEffect((): void => {
    onUserInactive(hideNavBar, showNavBar, INACTIVE_USER_DELAY);
  }, []);

  const hideNavBar = (): void => {
    setIsNavBarVisible(false);
  };

  const showNavBar = (): void => {
    setIsNavBarVisible(true);
  };

  const renderLogo = (): ReactElement => {
    return (
      <div className={`${styles.topOverlay} ${isNavBarVisible ? styles.topOverlayIn : ''} flexbox _full-width _position-absolute flex-items-center spacing-p-l-6`}>
        <Thumbnail
          data={{
            type: ThumbnailType.IMAGE,
            imageSrc: LogoFull as string,
          }}
          onClick={(): void => {
            window.location.href = window.PMW.util.site_url('');
          }}
          className={styles.logo}
        />
      </div>
    );
  };

  return (
    <div className={`flex-center ${styles.webpage} ${className}`} ref={posterWebpageRef}>
      <PosterWhiteboard
        className={styles.whiteboard}
        posterOpts={props.posterOpts}
        isWebpage={true}
      />
      <React.StrictMode>
        {renderLogo()}
        <PosterWebPageNavBar
          isFullScreen={isFullscreen}
          onToggleFullScreen={toggleFullscreen}
          canEditPoster={props.posterWebPageConfig.canEditPoster}
          qrCodeUrl={props.posterWebPageConfig.qrCodeUrl}
          isNavBarVisible={isNavBarVisible}
        />
      </React.StrictMode>
    </div>
  );
}
